module.exports = __webpack_public_path__ + "assets/img/title-31f36b47.png";